import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CommodityForecastChart = ({ onClick }) => {
  const data = {
    labels: ['Containerized', 'Dry Bulk', 'Liquid Bulk', 'Break Bulk'],
    datasets: [
      {
        label: '2023 Actual',
        data: [1.00, 0.73, 0.34, 0.11],
        backgroundColor: 'rgba(77, 166, 255, 0.7)',
        borderColor: '#4da6ff',
        borderWidth: 1
      },
      {
        label: '2024 Forecast',
        data: [1.14, 0.80, 0.32, 0.12],
        backgroundColor: 'rgba(255, 159, 64, 0.7)',
        borderColor: '#ff9f40',
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements) => {
      if (elements.length > 0 && onClick) {
        const element = elements[0];
        const datasetIndex = element.datasetIndex;
        const index = element.index;
        const dataset = data.datasets[datasetIndex];
        const value = dataset.data[index];
        const label = data.labels[index];
        const datasetLabel = dataset.label;
        
        onClick({
          label,
          value,
          datasetLabel,
          datasetIndex,
          index,
          year: datasetLabel.includes('2023') ? 2023 : 2024,
          commodityType: label
        });
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Million Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          callback: function(value) {
            return value.toFixed(2) + 'M';
          }
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.dataset.label || '';
            const value = context.parsed.y;
            return `${label}: ${value.toFixed(2)}M Tons`;
          }
        }
      }
    }
  };

  return <Bar data={data} options={options} />;
};

export default CommodityForecastChart;